import { PublicSiteInformation } from 'model';

export const siteSettingsTextReplacements = (siteSettings: PublicSiteInformation | undefined, body: string) => {
	if (siteSettings) {
		body = body?.replace(/\{siteName\}/gi, siteSettings.siteName);
		body = body?.replace(/\{description\}/gi, siteSettings.description);
		body = body?.replace(/\{legalName\}/gi, siteSettings.legalName);
	}
	return body;
};
